export interface IGoogleSearchScreenshot {
    id: number;
    filename: string;
    modified_date: string;
    year?: number;
    month?: number;
}

export type GoogleSearchVerificationState =
  | 'idle'
  | 'qr_required'
  | 'verified'
  | 'timeout'
  | 'failed';

export interface IGoogleSearchVerificationCurrent {
    run_id: string | null;
    state: GoogleSearchVerificationState;
    account_email: string | null;
    required_at: string | null;
    verified_at: string | null;
    qr_filename: string | null;
    qr_image_url: string | null;
    message: string | null;
    updated_at?: string | null;
}

export interface IGoogleSearchVerificationItem {
    id: string;
    run_id: string | null;
    account_email: string | null;
    state: GoogleSearchVerificationState;
    required_at: string | null;
    verified_at: string | null;
    duration_sec: number | null;
    qr_filename: string | null;
    qr_image_url: string | null;
    message: string | null;
    created_at: string;
}

export interface IGoogleSearchVerificationHistory {
    items: IGoogleSearchVerificationItem[];
    total: number;
    limit: number;
    offset: number;
}

export interface IGoogleSearchState {
    status: number | null;
    total: number | null;
    done: number | null;
    message?: string;
    logs?: string[] | null;
    verification_current?: IGoogleSearchVerificationCurrent | null;
    verification_pending?: IGoogleSearchVerificationCurrent[] | null;
}

export const googleSearchInitialState: IGoogleSearchState = {
    status: null,
    total: null,
    done: null,
    verification_current: null,
    verification_pending: [],
};
